








import ProjectManager from '@/components/settings/ProjectManager.vue'

export default {
    components: {
        ProjectManager
    },
    data() {
        return {}
    }
}
